module.exports = __webpack_public_path__ + "img/pass.5fc29130.svg";